import React, { } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setConfigSelectedTarget, setStep } from "../../../store/components/MarketExplorer.slice";
import { filterSelections, getCountryCode, getModuleCode, getPackage, getPackageObj, renderTargetSelectionItems, sortSelectionsPerSeqNo } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import MarketExplorerContainer from "./MarketExplorerContainer";
import MarketExplorerServices from "../../../services/MarketExplorer.services";

function TargetSelection() {
    const dispatch = useDispatch();
    const { setup } = useSelector((state) => state.buildTargets);
    const {
        configuration: {
            toEditData
        }
    } = useSelector((state) => state.marketExplorer);
    const onClick = (item) => {
        dispatch(setConfigSelectedTarget(item));
        dispatch(setStep(2));
    };
    const explorerList = MarketExplorerServices.getMarketExplorerList();

    const buildTargetsTemp = filterSelections(explorerList.buildTargets);
    const behaviorListTemp = filterSelections(explorerList.behavioralAndAttributes);
    const { buildTargets, behaviorList } = sortSelectionsPerSeqNo(buildTargetsTemp, behaviorListTemp)

    const { title, subTitle } = (() => {
        let titleText = "Build Targets";
        let subTitleText = "Define your query using one of the following methods";
        const OICode = getPackage();
        if (OICode === "whitespaces") {
            subTitleText = "Select an entry-point.";
            if (toEditData.data) {
                titleText = "";
                subTitleText = "";
            }
        } else if (OICode === "aitag") {
            subTitleText = "Track any site or page on the web, then extracts behavioral attributes on its visitors.";
        }
        return {
            title: titleText,
            subTitle: subTitleText
        };
    })();

    const isShow = (() => {
        const { code } = getPackageObj() || {};
        if (["gdn", "tiktokaudiences", "lineaudience", "yahoodisplay", "connectedtv"].includes(code?.replace("dev", ""))) return false;
        return !(code?.replace("dev", "") === "facebookaudiences" && getCountryCode("enterprise") === "vn");
    })();
    return (
        <div className="targetSelection">
            <MarketExplorerContainer
                className="reportBuilder-leftside_targets-selection"
                title={title}
                subTitle={subTitle}
            >
                {setup.marketPackage && (
                    <>
                        {buildTargets.map((item) => renderTargetSelectionItems(item, onClick))}
                        {setup.marketPackage.parent.oiCode === "consumer" && isShow && <p className="behavior-title">Behavior &amp; Attributes</p>}
                        {behaviorList.reduce((acc, item, idx) => {
                            acc.push(renderTargetSelectionItems(item, onClick));
                            if (behaviorList.length - 1 !== idx) {
                                if (item.typeToDiplay) {
                                    acc.push(<span className="c-bg-400 or-el">{!item?.dontDisplayType ? item.typeToDiplay : ""}</span>);
                                }
                            }
                            return acc;
                        }, [])}
                    </>
                )}
            </MarketExplorerContainer>
        </div>
    );
}
export default TargetSelection;
